export const ru = {
    be: 'Белорусский',
    de: 'Немецкий',
    en: 'Английский',
    kz: 'Казахский',
    'language-not-set': 'Выберите язык',
    ru: 'Русский',
    tr: 'Турецкий',
    ua: 'Украинский'
};
